import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../lang/en.json";
import he_IL from "../lang/he_IL.json";
import es from "../lang/es.json";
import pt_BR from "../lang/pt_BR.json";
import de from "../lang/de.json";
import fr from "../lang/fr.json";
import it from "../lang/it.json";
import zh_CN from "../lang/zh_CN.json";
import zh_TW from "../lang/zh_TW.json";
import ja from "../lang/ja.json";
import ko from "../lang/ko.json";
import cs from "../lang/cs.json";
import da from "../lang/da.json";
import id from "../lang/id.json";
import lt from "../lang/lt.json";
import hu from "../lang/hu.json";
import nl from "../lang/nl.json";
import no from "../lang/no.json";
import pl from "../lang/pl.json";
import ro from "../lang/ro.json";
import fi from "../lang/fi.json";
import sv from "../lang/sv.json";
import tr from "../lang/tr.json";
import el from "../lang/el.json";
import ru from "../lang/ru.json";
import bg from "../lang/bg.json";
import hi from "../lang/hi.json";
import th from "../lang/th.json";
import pt from "../lang/pt.json";

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: en,
    },
    he_IL: {
      translation: he_IL,
    },
    es: {
      translation: es,
    },
    pt_BR: {
      translation: pt_BR,
    },
    de: {
      translation: de,
    },
    fr: {
      translation: fr,
    },
    it: {
      translation: it,
    },
    "zh-CN": {
      translation: zh_CN,
    },
    "zh-TW": {
      translation: zh_TW,
    },
    ja: {
      translation: ja,
    },
    ko: {
      translation: ko,
    },
    cs: {
      translation: cs,
    },
    da: {
      translation: da,
    },
    id: {
      translation: id,
    },
    lt: {
      translation: lt,
    },
    hu: {
      translation: hu,
    },
    nl: {
      translation: nl,
    },
    no: {
      translation: no,
    },
    pl: {
      translation: pl,
    },
    ro: {
      translation: ro,
    },
    fi: {
      translation: fi,
    },
    sv: {
      translation: sv,
    },
    tr: {
      translation: tr,
    },
    el: {
      translation: el,
    },
    ru: {
      translation: ru,
    },
    bg: {
      translation: bg,
    },
    hi: {
      translation: hi,
    },
    th: {
      translation: th,
    },
    pt: {
      translation: pt,
    },
  },
});

export default i18n;
